import { TRACE_PROVIDERS, TraceProviderId } from "../constants/traceProviders";

import { ProviderIcon } from "@/components/ProviderWithLogo";
import { cn } from "@/lib/utils";

interface ProviderCardGridProps {
  selectedProviderId: TraceProviderId;
  onSelectProvider: (providerId: TraceProviderId) => void;
}

export const ProviderCardGrid = ({
  selectedProviderId,
  onSelectProvider,
}: ProviderCardGridProps) => (
  <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
    {TRACE_PROVIDERS.map(provider => {
      const isSelected = provider.id === selectedProviderId;

      return (
        <button
          key={provider.id}
          type="button"
          onClick={() => onSelectProvider(provider.id)}
          className={cn(
            "rounded-xl border p-3 text-left transition-colors",
            isSelected
              ? "border-blue-500 bg-blue-50/40"
              : "border-gray-200 bg-white hover:border-blue-200",
          )}
        >
          <div className="flex items-center gap-2.5">
            <div className="flex h-7 w-7 shrink-0 items-center justify-center overflow-visible rounded-md border border-gray-100 bg-white">
              <ProviderIcon
                provider={provider.logoProvider}
                className={cn("h-4 w-4", provider.logoProvider === "promptlayer" && "scale-125")}
                colored
              />
            </div>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-gray-900">{provider.title}</p>
              <p className="mt-0.5 text-xs leading-snug text-gray-600">{provider.description}</p>
            </div>
          </div>
        </button>
      );
    })}
  </div>
);
